import React from 'react';
import './BiaCard.scss';

interface BiaCardProps {
  children: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

const BiaCard: React.FC<BiaCardProps> = ({ children, style, className, onClick }) => (
  <div className={`bia-card ${className ?? ''}`} style={style}
    onClick={() => { if (onClick) onClick(); }}>
    {children}
  </div>
);

export default BiaCard;
